module.exports = __webpack_public_path__ + "img/send-failed.0ba019bd.svg";